import styled from 'styled-components';
import { COLORS } from '../../constants/colors';

// Fill the height of the page area the Messaging tab sits in, matching the
// Inbox conversation look (rounded card, chat layout).
export const ConversationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 280px);
  min-height: 360px;
  box-sizing: border-box;
  background: white;
`;

export const Header = styled.div`
  padding: 14px 20px;
  border-bottom: 1px solid ${COLORS.border};
  background: white;

  .name {
    font-weight: 600;
    color: ${COLORS.textDark};
  }

  .to {
    font-size: 13px;
    color: ${COLORS.textMedium};
    margin-top: 2px;

    span {
      color: ${COLORS.$primaryBlue};
    }
  }
`;

export const FromRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px 0;
  background: white;

  span {
    font-size: 12px;
    color: ${COLORS.textMedium};
  }
`;
